// BANGUOJA PDP v2 (Mondri stilius) – žr. snippets/bj-pdp-v2-items.liquid ir bj-pdp-v2-extras.liquid.
// Tema (Prestige) po kiekvieno varianto pakeitimo iš naujo atsiunčia „liquid“ blokus, todėl:
//  * visi įvykiai deleguoti per document;
//  * varnelių ir pasirinktų dydžių būsena laikoma window.__bjPdp ir atstatoma, kai blokas įterpiamas iš naujo;
//  * užkrautos „related“ rekomendacijos kešuojamos.
if (!window.__bjPdp) {
  const state = (window.__bjPdp = { main: {}, extras: {}, recs: {} });
  const isV2 = () => document.documentElement.getAttribute('data-bj-pdp') === 'v2';

  const rowKey = (items, row) => `${items.dataset.productId}:${row.dataset.productId}`;

  // ---------- Būsenos atstatymas ----------
  function applyState(items) {
    const pid = items.dataset.productId;

    const mainCheck = items.querySelector('[data-main="true"] [data-bj-item-check]');
    if (mainCheck && pid in state.main) mainCheck.checked = state.main[pid];

    items.querySelectorAll('[data-bj-item][data-main="false"]').forEach((row) => {
      const saved = state.extras[rowKey(items, row)];
      if (!saved) return;
      const check = row.querySelector('[data-bj-item-check]');
      const select = row.querySelector('[data-bj-extra-variant]');
      if (select && saved.variantId && select.querySelector(`option[value="${saved.variantId}"]`)) {
        select.value = saved.variantId;
        row.dataset.variantId = saved.variantId;
      }
      if (check) check.checked = !!saved.checked;
    });

    const slot = items.querySelector('[data-bj-recs-url]');
    if (slot) loadRecs(items, slot);

    items.querySelectorAll('[data-bj-desc]').forEach(refreshDesc);
  }

  function init(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-bj-items]')) applyState(root);
    root.querySelectorAll('[data-bj-items]').forEach(applyState);
    if (root.matches && root.matches('[data-bj-desc]')) refreshDesc(root);
    root.querySelectorAll('[data-bj-desc]').forEach(refreshDesc);
  }

  // ---------- „Related“ rekomendacijos (kai nėra to paties dizaino / kolekcijos prekių) ----------
  const pending = new Set();

  function fillRecs(slot, pid, html) {
    slot.innerHTML = `<p class="bj-items__caption">${slot.dataset.caption || ''}</p>${html}`;
    slot.querySelectorAll('[aria-controls="bj-v2-size-guide"]').forEach((button) => button.setAttribute('aria-controls', `bj-v2-size-guide-${pid}`));
    slot.removeAttribute('data-bj-recs-url');
    slot.hidden = false;
    const items = slot.closest('[data-bj-items]');
    if (items) applyState(items);
  }

  async function loadRecs(items, slot) {
    const pid = items.dataset.productId;

    if (pid in state.recs) {
      if (state.recs[pid]) fillRecs(slot, pid, state.recs[pid]);
      return;
    }
    if (pending.has(pid)) return;
    pending.add(pid);

    let html = '';
    try {
      const response = await fetch(slot.dataset.bjRecsUrl);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const rows = doc.querySelector('[data-bj-recs-rows]');
      html = rows && rows.children.length ? rows.innerHTML : '';
    } catch (e) {
      html = '';
    }

    state.recs[pid] = html;
    pending.delete(pid);

    // blokas galėjo būti perpieštas, kol laukėme atsakymo – pildome aktualų elementą
    const current = document.querySelector(`[data-bj-items][data-product-id="${pid}"] [data-bj-recs-url]`);
    if (current && html) fillRecs(current, pid, html);
  }

  // ---------- Aprašymo „Skaityti plačiau“ ----------
  function refreshDesc(wrapper) {
    if (wrapper.classList.contains('is-expanded')) return;
    const content = wrapper.querySelector('[data-bj-desc-content]');
    const toggle = wrapper.querySelector('[data-bj-desc-toggle]');
    if (!content || !toggle || !content.clientHeight) return;
    const clamped = content.scrollHeight > content.clientHeight + 1;
    toggle.hidden = !clamped;
    wrapper.classList.toggle('is-clamped', clamped);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-bj-desc-toggle]');
    if (!toggle) return;
    const wrapper = toggle.closest('[data-bj-desc]');
    const expanded = !wrapper.classList.contains('is-expanded');
    wrapper.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
  });

  document.addEventListener('toggle', (event) => {
    if (event.target && event.target.querySelectorAll) event.target.querySelectorAll('[data-bj-desc]').forEach(refreshDesc);
  }, true);

  // ---------- Atsiliepimai: temų filtrai, „Rodyti daugiau“, „Skaityti visą“ ----------
  const REV_STEP = 6;

  function refreshRevReads(root) {
    root.querySelectorAll('[data-bj-rev]:not([hidden])').forEach((rev) => {
      if (rev.classList.contains('is-open')) return;
      const body = rev.querySelector('[data-bj-rev-body]');
      const read = rev.querySelector('[data-bj-rev-read]');
      if (body && read && body.clientHeight) read.hidden = !(body.scrollHeight > body.clientHeight + 1);
    });
  }

  function showRevs(wrap, limit) {
    const filter = wrap.dataset.filter || '';
    let shown = 0;
    let matching = 0;
    wrap.querySelectorAll('[data-bj-rev]').forEach((rev) => {
      const match = !filter || (` ${rev.dataset.tags} `).includes(` ${filter} `);
      if (match) matching += 1;
      const visible = match && shown < limit;
      if (visible) shown += 1;
      rev.hidden = !visible;
    });
    wrap.dataset.limit = String(limit);
    const more = wrap.querySelector('[data-bj-rev-more]');
    if (more) more.hidden = shown >= matching;
    refreshRevReads(wrap);
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest && event.target.closest('[data-bj-rev-filter]');
    if (chip) {
      const wrap = chip.closest('[data-bj-revs]');
      wrap.dataset.filter = chip.dataset.bjRevFilter;
      wrap.querySelectorAll('[data-bj-rev-filter]').forEach((other) => {
        other.classList.toggle('is-active', other === chip);
        other.setAttribute('aria-pressed', String(other === chip));
      });
      showRevs(wrap, 4);
      return;
    }
    const more = event.target.closest && event.target.closest('[data-bj-rev-more]');
    if (more) {
      const wrap = more.closest('[data-bj-revs]');
      showRevs(wrap, (parseInt(wrap.dataset.limit, 10) || 4) + REV_STEP);
      return;
    }
    const read = event.target.closest && event.target.closest('[data-bj-rev-read]');
    if (read) {
      const rev = read.closest('[data-bj-rev]');
      rev.classList.toggle('is-open');
    }
  });

  document.addEventListener('toggle', (event) => {
    if (event.target && event.target.querySelectorAll) event.target.querySelectorAll('[data-bj-revs]').forEach(refreshRevReads);
  }, true);

  // ---------- Žiedo dydžiai mygtukais (valdo paslėptą temos variant-picker'į) ----------
  document.addEventListener('click', (event) => {
    const pill = event.target.closest && event.target.closest('[data-bj-size]');
    if (!pill) return;
    const formId = pill.dataset.form;
    const input = document.querySelector(`input[form="${formId}"][name="${formId}-option${pill.dataset.optionPosition}"][value="${pill.dataset.value}"]`);
    if (!input) return;
    pill.parentElement.querySelectorAll('[data-bj-size]').forEach((other) => {
      other.classList.toggle('is-selected', other === pill);
      other.setAttribute('aria-pressed', String(other === pill));
    });
    if (input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Pasirinkimai ----------
  document.addEventListener('change', (event) => {
    const target = event.target;
    const row = target.closest && target.closest('[data-bj-item]');
    const items = row && row.closest('[data-bj-items]');
    if (!row || !items) return;

    if (target.matches('[data-bj-item-check]')) {
      if (row.dataset.main === 'true') {
        state.main[items.dataset.productId] = target.checked;
      } else {
        const key = rowKey(items, row);
        state.extras[key] = { ...(state.extras[key] || {}), checked: target.checked };
        if (!target.checked) {
          const error = row.querySelector('[data-bj-item-error]');
          if (error) error.hidden = true;
        }
      }
      return;
    }

    if (target.matches('[data-bj-extra-variant]')) {
      const key = rowKey(items, row);
      row.dataset.variantId = target.value;
      const check = row.querySelector('[data-bj-item-check]');
      if (target.value && check) check.checked = true;
      state.extras[key] = { checked: check ? check.checked : false, variantId: target.value };
      const error = row.querySelector('[data-bj-item-error]');
      if (error && target.value) error.hidden = true;
      return;
    }

    if (target.matches('[data-bj-main-size]')) {
      const formId = target.dataset.form;
      const position = target.dataset.optionPosition;
      const input = document.querySelector(`input[form="${formId}"][name="${formId}-option${position}"][value="${target.value}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  // ---------- „Į krepšelį“ su papildomomis prekėmis ----------
  function cleanup(form) {
    form.querySelectorAll('.bj-injected').forEach((input) => input.remove());
    if (form.elements.id && form.elements.id.dataset && form.elements.id.dataset.bjDisabled) {
      form.elements.id.disabled = false;
      delete form.elements.id.dataset.bjDisabled;
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isV2()) return;

    // form.id grąžintų lauką name="id", todėl ID imame iš atributo
    // pagrindinė prekė ir rekomendacijos yra atskiruose blokuose (tarp jų – „Nebėra tavo dydžio?“)
    const selector = `[data-bj-items][data-form="${form.getAttribute('id')}"]`;
    const containers = Array.from(document.querySelectorAll(selector));
    if (!containers.length) return;
    const items = containers[0];
    const pick = (query) => containers.flatMap((container) => Array.from(container.querySelectorAll(query)));

    const mainCheck = pick('[data-main="true"] [data-bj-item-check]')[0];
    const mainOn = !mainCheck || mainCheck.checked;
    const extras = [];
    let missing = null;

    pick('[data-bj-item][data-main="false"]').forEach((row) => {
      const check = row.querySelector('[data-bj-item-check]');
      if (!check || !check.checked) return;
      if (!row.dataset.variantId) {
        const error = row.querySelector('[data-bj-item-error]');
        if (error) error.hidden = false;
        missing = missing || row;
        return;
      }
      extras.push(row.dataset.variantId);
    });

    if (missing) {
      event.preventDefault();
      event.stopImmediatePropagation();
      missing.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (mainOn && extras.length === 0) return; // įprastas temos kelias

    if (!mainOn && extras.length === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    cleanup(form);
    const idInput = form.elements.id;
    const mainId = idInput ? idInput.value : null;
    if (idInput) {
      idInput.disabled = true;
      idInput.dataset.bjDisabled = '1';
    }

    const add = (variantId) => {
      [['id', variantId], ['quantity', '1']].forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `items[][${name}]`;
        input.value = value;
        input.className = 'bj-injected';
        form.appendChild(input);
      });
    };

    if (mainOn && mainId) add(mainId);
    extras.forEach(add);

    const done = () => cleanup(form);
    const added = () => {
      cleanup(form);
      // sėkmingai įdėjus – papildomas prekes atžymime, kad kitas paspaudimas jų nedubliuotų
      // (būseną išsaugome kaip „nepažymėta“, kad perpiešus iš anksto pažymėta rekomendacija neatsirastų vėl)
      const pid = items.dataset.productId;
      document.querySelectorAll(`[data-bj-items][data-product-id="${pid}"] [data-bj-item][data-main="false"]`).forEach((row) => {
        const check = row.querySelector('[data-bj-item-check]');
        if (check) check.checked = false;
        state.extras[`${pid}:${row.dataset.productId}`] = { checked: false, variantId: row.dataset.variantId || '' };
      });
    };
    form.addEventListener('variant:add', added, { once: true });
    form.addEventListener('cart:error', done, { once: true });
    setTimeout(done, 10000);
  }, true);

  // ---------- Pradžia ir perpiešimai ----------
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      init(node);
      if (node.matches('.bj-coll__link') || node.querySelector('.bj-coll__link')) requestAnimationFrame(fitColl);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  init(document);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => document.querySelectorAll('[data-bj-desc]').forEach(refreshDesc));

  // ---------- „Kolekcija: …“ – visada viena eilutė (jei netelpa, šriftas mažinamas iki 8 px) ----------
  const fitColl = () => {
    document.querySelectorAll('.bj-coll__link').forEach((link) => {
      link.style.fontSize = '';
      let size = parseFloat(getComputedStyle(link).fontSize);
      while (link.scrollWidth > link.clientWidth + 1 && size > 8) {
        size -= 0.3;
        link.style.fontSize = `${size}px`;
      }
    });
  };
  fitColl();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitColl);
  window.addEventListener('resize', fitColl, { passive: true });
}
